import styled from 'styled-components';

export const Progress = styled.div<{ value?: number }>`
    width: ${({ value = 0 }) => value}%;
    height: 5px;
    border-radius: 40px 0px 0px 40px;

    background: #1069f7;
`;
